import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SelectedState.css';
import {
  getURLForNavKey,
  HEADER,
  SUMMARY_TLDR,
  FULL_BLEED_IMAGE,
} from './lib/data';

export default class SelectedState extends Component {
  static propTypes = {
    template: PropTypes.string,
  }

  templatesThatDoNotRenderSelectedState = [
    FULL_BLEED_IMAGE,
    HEADER,
    SUMMARY_TLDR,
  ]

  shouldHideSelectedState() {
    return this.templatesThatDoNotRenderSelectedState.includes(this.props.template);
  }

  handleClick = (e) => {
    window.location.href = getURLForNavKey(e.target.getAttribute("data-key"));
  }

  render() {
    if (this.shouldHideSelectedState()) {
      return null;
    }

    return (
      <section className="selected-state">
        <ul>
          <li onClick={this.handleClick} data-key="what-is-culture" className="what-is-culture">what is culture?</li>
          <li onClick={this.handleClick} data-key="why-our-company-exists" className="purpose">purpose</li>
          <li onClick={this.handleClick} data-key="how-teams-put-values-to-work" className="actions">actions</li>
          <li onClick={this.handleClick} data-key="what-individuals-contribute" className="skills">skills</li>
          <li onClick={this.handleClick} data-key="next-steps" className="whats-next">next steps</li>
        </ul>
      </section>
    );
  }
}
